let initialized = false;

export function resetInitialized() {
	initialized = false;
}

export const initializeLogRocket = (environment: string, projectId: string): void => {
	if (!environment || environment !== 'prod' || !projectId || initialized) return;

	if (typeof globalThis !== 'undefined' && globalThis.LogRocket) {
		initialized = true;
		return;
	}

	initialized = true;

	import('logrocket')
		.then(({ default: LR }) => {
			try {
				LR.init(projectId);
				globalThis.LogRocket = LR;
			} catch {
				// LogRocket init can fail in certain browser environments.
				// Reset flag to allow retry on next navigation.
				initialized = false;
			}
		})
		.catch(() => {
			// Dynamic import can fail due to network issues.
			// Reset flag to allow retry on next navigation.
			initialized = false;
		});
};
